angular
    .module('empower.control')
    .service('popupService', ['$rootScope', '$q', '$window', function ($rootScope, $q, $window) {
        return {
            showText: showText,
            showDialog: showDialog,
            showError: showError,
            showExternalText: showExternalText,
            showExternalError: showExternalError,
            show: show,
            hide: hide, // return a defer
            update: update,
            showValidationClientErrors: showValidationClientErrors,
            showValidationServerErrors: showValidationServerErrors,
            showMultiActionDialog: showMultiActionDialog,
            showLocalitySearchPopup: showLocalitySearchPopup
        };

        function showText(message, title, okCallback) {
            show('index', 'infor-popup', {
                title: title,
                message: message,
                showCloseButton: false,
                okCallback: function () {
                    if (typeof okCallback === 'function') {
                        okCallback.call(this);
                    } else {
                        hide();
                    }
                }
            });
        }

        function showDialog(message, title, options) {
            show('index', 'infor-popup', {
                title: title,
                message: message,
                showCloseButton: false,
                additionClass: options.additionClass,
                okCallback: function () {
                    if (typeof options.okCallback === 'function') {
                        options.okCallback.call(this);
                    } else {
                        hide();
                    }
                }
            });
        }

        //listAction should be object like {text: 'text', actionCallback: callback, buttonClass: 'btn-primary', buttonIcon: 'glyphicon glyphicon-forward'}
        function showMultiActionDialog(message, title, listAction){
            show('index', 'multi-action-popup', {
                title: title,
                message: message,
                showCloseButton: false,
                listAction: listAction
            });
        }

        // Show external EML text
        function showExternalText(message, isInternalLogin, okCallback) {
            show('index', 'infor-popup', {
                showEMLLogo: !isInternalLogin,
                message: message,
                okCallback: function () {
                    if (typeof okCallback === 'function') {
                        okCallback.call(this);
                    } else {
                        hide();
                    }
                }
            });
        }
        function showExternalError(error, isInternalLogin, okCallback, cancelCallback) {
            var controller = {
                showEMLLogo: !isInternalLogin,
                message: error
            };

            controller.okCallback = function () {
                if (typeof okCallback === 'function') {
                    okCallback.call(controller.okCallback);
                } else {
                    hide();
                }
            };

            //set null the previous CancelCallback if it exists
            controller.cancelCallback = undefined;

            if (typeof cancelCallback === 'function') {
                controller.cancelCallback = function () {
                    cancelCallback.call(controller);
                }
            }

            show('index', 'generic-error-popup', controller);
        }

        function showError(error, title, okCallback, cancelCallback) {
            var controller = {
                title: title,
                message: error,
                showCloseButton: false
            };

            controller.okCallback = function () {
                if (typeof okCallback === 'function') {
                    okCallback.call(controller.okCallback);
                } else {
                    hide();
                }
            };

            //set null the previous CancelCallback if it exists
            controller.cancelCallback = undefined;

            if (typeof cancelCallback === 'function') {
                controller.cancelCallback = function () {
                    cancelCallback.call(controller);
                }
            }

            show('index', 'generic-error-popup', controller);
        }
        function showValidationClientErrors(form) {
            var summaryMessage = "Some data missing or invalid";
            var controller = {
                errors: form.$error,
                form: form,
                message: summaryMessage,
                okCallback: function () {
                    hide();
                }
            };
            show('index', 'validation-client-error-popup', controller);
        }
        function showValidationServerErrors(errorResult, title, okCallback, cancelCallback) {
            var genericMessage = "Unexpected errors occurred.";
            var summaryMessage = errorResult.SummaryMessage || genericMessage;
            var controller = {
                errors: errorResult.Errors || [],
                message: summaryMessage,
                title: title,
                showCloseButton: false
            };
            controller.okCallback = function () {
                if (typeof okCallback === 'function') {
                    okCallback.call(controller.okCallback);
                } else {
                    $window.location = "/";
                }
            };

            //set null the previous CancelCallback if it exists
            controller.cancelCallback = undefined;

            if (typeof cancelCallback === 'function') {
                controller.cancelCallback = function () {
                    cancelCallback.call(controller);
                }
            }
            show('index', 'validation-server-error-popup', controller);

        }
        function show(moduleName, modelName, controller) {
            var url = 'module/' + moduleName + '/view/' + modelName + '.html';
            $rootScope.$broadcast('show-common-popup', controller, url);
        }

        function update(moduleName, modelName, controller) {
            $rootScope.$broadcast('show-common-popup', controller);
        }

        function hide() {
            var def = $q.defer();
            $rootScope.$broadcast('hide-common-popup', def);
            return def.promise;
        }

        function showLocalitySearchPopup(options) {
            $rootScope.$broadcast('show-locality-search-popup', options);
        }
    }]);
